import { on } from '@ember/modifier';
import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';

import type { Service } from 'webapp-types';
import { PopupEvent } from 'webapp/enums/enums';
import { isAlive } from 'webapp/utils/common';

import CommonUiIconComponent from 'webapp/components/common/ui-icon';
import GoalsMeasurementPopupComponent from 'webapp/components/goals/measurement/popup';

import type { Goal } from 'webapp/models-custom';

interface Args {
	model: Goal;
}
export default class GoalsMeasurementForDropdownComponent extends Component<Args> {
	@service('model-manager/goals') declare mmGoalsService: Service.ModelManager.Goals;
	@service('popup') declare popupService: Service.Popup;

	@tracked isPopupOpen = false;

	get model() {
		return this.args.model;
	}

	get label() {
		const option = this.mmGoalsService.measurementOptions.find(
			(option) => option.value === this.model.measurement,
		);
		return option?.label2 || '#';
	}

	@action
	openPopup(event: PointerEvent) {
		if (this.isPopupOpen) {
			return;
		}

		const dropDownEl = (event.target as HTMLElement).closest('.dropdown')!,
			attachTo = dropDownEl.querySelector<HTMLElement>('ui-icon')!;

		if (!attachTo) {
			return;
		}

		const popup = this.popupService.createContext(GoalsMeasurementPopupComponent, attachTo, {
			popupClass: 'optionspopup popup-type-goal-measurement',
		});

		popup.open({
			model: this.model,
		});

		this.isPopupOpen = true;

		popup.on(PopupEvent.CLOSED, this, () => {
			if (isAlive(this)) {
				this.isPopupOpen = false;
			}
		});
	}
	<template>
		<div class="dropdown">
			<a role="button" {{on "click" this.openPopup}}>
				<div>{{this.label}}</div>
				<CommonUiIconComponent @name="ChevronDown" @size="sm" />
			</a>
		</div>
	</template>
}
